import { Chip, Typography, Link, Box, Stack } from "@mui/material";
import { useVideoTutorial } from "../../contexts/video-tutorial-context/video-tutorial-context";
import { keyframes } from "@mui/system";

const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.4); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 8px rgba(255, 107, 107, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 107, 107, 0); }
`;

export default function NewFeatureChip({
  message,
  label = "New",
  tutorialSrc,
}: {
  message: string;
  label?: string;
  tutorialSrc?: string;
}) {
  const { showVideoTutorial } = useVideoTutorial();

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, rgba(255, 243, 205, 0.9), rgba(255, 230, 180, 0.9))",
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        p: 1.5,
        transition: "all 0.25s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          transform: "translateY(-1px)",
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Chip
          label={label}
          size="small"
          sx={{
            background: "linear-gradient(135deg, #ff6b6b, #feca57)",
            color: "white",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            px: 1.2,
            borderRadius: "8px",
            animation: `${pulse} 2s infinite`,
          }}
        />

        <Typography variant="body2" sx={{ color: "text.primary" }}>
          {message}
          {tutorialSrc && (
            <>
              {" "}
              <Link
                component="button"
                onClick={() => showVideoTutorial(tutorialSrc)}
                sx={{
                  fontWeight: 500,
                  cursor: "pointer",
                  color: "primary.main",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Learn more
              </Link>
            </>
          )}
        </Typography>
      </Stack>
    </Box>
  );
}
